export default {
  planMeta: {
    planType: '',
  },
  planId: '', // url上取的planId
  // 归档任务列表
  taskLoading: false,
  // 附件列表
  fileLoading: false,
  searchParams: {
    // pageNum: 1,
    // pageSize: 10,
    fullPath: localStorage.getItem('fullPath')
      ? localStorage.getItem('fullPath')
      : '/',
    pathName: localStorage.getItem('pathName')
      ? localStorage.getItem('pathName')
      : '',
    fileType: 'All',
    title: '',
    officerIds: null,
    subjectIds: null,
    focusFlag: null,
  },
  navPath: '',
  fileListType: localStorage.getItem('layoutType')
    ? localStorage.getItem('layoutType')
    : 'list',
  attachmentList: [],
  attachmentsTotal: 0,
};
